import React, { useState } from "react";
import { Form, ProgressBar, Button } from "react-bootstrap";
import ReactS3Uploader from "react-s3-uploader";
import { injectIntl } from "react-intl";

import getToken from "../helpers/getToken";
import getEncodedImageUrl from "../helpers/getEncodedImageUrl";

import ImgToolTip from "../components/ImgTooltip"

const ImageUploadCustom = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  intl,
  ...props
}) => {
  const [showUpload, setShowUpload] = useState(0);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);


  //console.log("value1",value1)
  return (
    <Form.Group controlId={name}>
      {props.label && (
        <Form.Label>
          {props.label}
          {props.required && <span className="text-danger">*</span>}
        </Form.Label>
      )}
      <div className="upload-photo custom-image-upload-container">
        <div className="text-center custom-image-upload">
          {props.defaultImage ? (
            <img
              className="event-portrait"
              src={
                value ? getEncodedImageUrl(value, 200, 200) : props.defaultImage
              }
              alt=""
            />
          ) : (
            
              <img
                className="event-portrait"
                src={
                  value
                    ? getEncodedImageUrl(value, 200, 200)
                    : "/images/default-event-ico.png"
                }
                alt=""
              />
            )}
        </div>
        <div className="edit-image-ico">
          <label htmlFor={props.id} className="edit-ico-cont">
              <ImgToolTip intl={intl} placement="top" tooltiptext={props.buttonEmpty} id="tooltip-upload-logo" img={`/icons/edit-ico.png`} />
          </label>
          <ReactS3Uploader
            type="file"
            id={props.id}
            accept={props.accept}
            signingUrl={props.signingUrl || "/s3"}
            signingUrlMethod="GET"
            preprocess={(file, next) => {
              // if (props.maxSize && file.size > parseInt(props.maxSize)) {
              //   Alert.warning(intl.formatMessage({ id: "error.fileTooBig" }));
              //   setShowFileSizeWarning(true)
              //   setTimeout(() => {
              //     setShowUpload(0);
              //     setShowFileSizeWarning(false)
              //   }, 3000);
              // } else {
                setShowUpload(1);
                next(file);
              // }
            }}
            onProgress={(p) => {

              console.log("upload progress", p)

              if (p === 0) {
                setShowUpload(p + 1);
              } else {
                setShowUpload(p)
              }
            }}
            onError={(err) => {

              console.log("upload props.signingUrl", props.signingUrl)
              console.log("upload err", err)
              // Alert.error(
              //   intl.formatMessage({
              //     id: "error.file-upload",
              //   })
              // );
              setShowError(true);
              setTimeout(() => {
                setShowUpload(0);
                setShowError(false);
              }, 3000);
            }}
            
            onFinish={(url) => {
              console.log("upload url", url) /////////////////////////////////////////////////////
              setFieldValue(name, url.filename);
              if(props.onChange) {
                props.onChange(url.filename)
              }
              // alert.success(intl.formatMessage({id: 'label.photoUploaded'}));
              setShowSuccess(true);
              setTimeout(() => {
                setShowUpload(0);
                setShowSuccess(false);
              }, 3000);
            }}
            signingUrlHeaders={{
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: props.token || getToken(),
            }}
            // signingUrlWithCredentials
            uploadRequestHeaders={{
              "x-amz-acl": "public-read",
            }}
            contentDisposition="auto"
            server={process.env.REACT_APP_API_HOST}
          />
        </div>
        {
          showUpload !== 0 && <div className="upload-file-progress-container">
            <div className="upload-file-progress">
              <p>{intl.formatMessage({ id: 'button.uploadingPhoto' })} {(showError || showSuccess) && <Button onClick={() => setShowUpload(0)} type="button"><img src="/icons/close.png" alt="close" /></Button>}</p>
              <div className="progress-container">
                <ProgressBar now={showUpload} label={`${showUpload}%`} />
                <span className="status-message text-success">{showSuccess && intl.formatMessage({ id: "label.photoUploaded" })}</span>
                <span className="status-message text-danger">{showError && intl.formatMessage({ id: "error.file-upload" })}</span>
              </div>
            </div>
          </div>
        }
      </div>
      {touched[name] && errors[name] ? (
        <Form.Text>{errors[name]}</Form.Text>
      ) : (
          ""
        )}
    </Form.Group>
  );
};

export default injectIntl(ImageUploadCustom);
